(() => {
  "use strict";

  window.addEventListener("load", function (e) {
    let accordions = document.querySelectorAll('.details.accordion-animate')

    const openAccordion = (accordion) => {
      const content = accordion.querySelector(".accordion__content");
      accordion.classList.add('open')
      content.style.maxHeight = content.scrollHeight + "px";
    };

    const closeAccordion = (accordion) => {
      const content = accordion.querySelector(".accordion__content");
      accordion.classList.remove('open')
      content.style.maxHeight = '';
    };

    accordions.forEach((accordion) => {
      const intro = accordion.querySelector(".summary");
      const content = accordion.querySelector(".accordion__content");

      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(accordion);
        }
      };
    });

  })
})()